import React from "react";
import {
  expedienteListStyle,
  expedienteStatusBannerStyle,
  expedienteColors,
  getExpedienteCardStyle,
  getExpedienteRowOuterStyle,
  getExpedienteRailColumnStyle,
  getExpedienteRailDotStyle,
  getExpedienteRailLineStyle,
  EXPEDIENTE_TIMELINE_KEYFRAMES,
} from "./expedienteTimelineStyles.ts";

const shimmerBar = (width: string | number, height: number): React.CSSProperties => ({
  display: "block",
  width,
  height,
  borderRadius: 6,
  background:
    "linear-gradient(90deg, #e2e8f0 0%, #f1f5f9 40%, #e2e8f0 80%)",
  backgroundSize: "200% 100%",
  animation: "expedienteSkelShimmer 1.35s ease-in-out infinite",
});

const ExpedienteTimelineSkeleton = ({ count = 7 }: { count?: number }) => {
  return (
    <>
      <style>{`
        ${EXPEDIENTE_TIMELINE_KEYFRAMES}
        @keyframes expedienteSkelShimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        @keyframes expedienteSkelSpin {
          to { transform: rotate(360deg); }
        }
      `}</style>

      <div style={expedienteStatusBannerStyle} aria-live="polite" aria-busy="true">
        <span
          style={{
            width: 18,
            height: 18,
            border: "2px solid #e2e8f0",
            borderTopColor: "#6366f1",
            borderRadius: "50%",
            animation: "expedienteSkelSpin 0.7s linear infinite",
            flexShrink: 0,
          }}
          aria-hidden
        />
        <span>Cargando expediente…</span>
      </div>

      <div style={expedienteListStyle}>
        {Array.from({ length: count }).map((_, index) => {
          const isLast = index === count - 1;
          return (
            <div key={`exp-skeleton-${index}`} style={getExpedienteRowOuterStyle()}>
              <div
                style={getExpedienteRailColumnStyle(
                  isLast,
                  expedienteColors.rail
                )}
              >
                <div
                  style={getExpedienteRailDotStyle(
                    expedienteColors.rail,
                    false
                  )}
                />
                {!isLast && <div style={getExpedienteRailLineStyle(isLast)} />}
              </div>
              <div style={{ ...getExpedienteCardStyle(false, false), flex: 1 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    padding: "14px 16px",
                    flexWrap: "wrap",
                  }}
                >
                  <span style={shimmerBar(72, 24)} />
                  <span
                    style={{
                      ...shimmerBar(40, 40),
                      borderRadius: 10,
                      flexShrink: 0,
                    }}
                  />
                  <span
                    style={{
                      ...shimmerBar(`${50 + (index % 3) * 10}%`, 18),
                      flex: 1,
                      minWidth: 120,
                      maxWidth: 320,
                    }}
                  />
                  <span
                    style={{
                      ...shimmerBar(36, 36),
                      borderRadius: 8,
                      flexShrink: 0,
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ExpedienteTimelineSkeleton;
